import classNames from 'classnames'

export const labelClassNames = (props: any) => {
  const { variation, stacked } = props

  return classNames({
    'text-secondary': variation === 'default',
    'flex flex-row items-center brand2': variation === 'default' && stacked,
    'inline-flex flex-row items-start brand2':
      variation === 'default' && !stacked,
    block: variation === 'web' && stacked,
    'inline-block': variation === 'web' && !stacked
  })
}

export const errorClassNames = (props: any) => {
  const { variation } = props
  return classNames({
    'absolute top-full w-max flex flex-row font-sansPro items-center text-error text-xs font-semibold left-0 leading-4 xl:-mb-[6px] before:content-[""] before:bg-icon-warning-outline before:bg-center before:bg-contain before:bg-no-repeat before:w-4 before:h-4 before:block before:mr-2':
      variation === 'default'
  })
}

export const inputClassNames = classNames('mr-1 appearance-none')
